import { render, staticRenderFns } from "./ReportDataPublicationViewCustomize.vue?vue&type=template&id=4a6e1017&scoped=true&"
import script from "./ReportDataPublicationViewCustomize.vue?vue&type=script&lang=ts&"
export * from "./ReportDataPublicationViewCustomize.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDataPublicationViewCustomize.vue?vue&type=style&index=0&id=4a6e1017&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e1017",
  null
  
)

export default component.exports